import { SHOW_CONTINGENCIES_INFORMATION_DIALOG } from './ContingencyExpenseDialog.actions'

const initialState = {
  open: false
}

/**
 * contingencyExpenseDialog's reducer.
 */
const contingencyExpenseDialog = (state = initialState, { payload, type }) => {
  switch (type) {
    case SHOW_CONTINGENCIES_INFORMATION_DIALOG: {
      return { ...state, open: payload.showDialog }
    }
    default: {
      return state
    }
  }
}

export default contingencyExpenseDialog
